import i18next from 'i18next'
import * as React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import {
  AuthButtonPrimary,
  FormControls,
  formSkeletonConfig,
  FormSkeletonLayout,
} from '../../utils/forms'
import { AuthState } from './authState'
import { getClassName, options } from './utils'

export function resend_activation_button(
  options: options,
  email: string,
  readonly: boolean,
  altHeader?: string
): Widget<Updater<AuthState>> {
  return fromJSX((setState: (_: Updater<AuthState>) => void) => (
    <FormSkeletonLayout
      type="resend-activation"
      kind="text-image"
      onSubmit={() =>
        setState((s) => ({
          ...s,
          resendActivationState: 'resend activation - resending',
        }))
      }
      options={options}
      image={formSkeletonConfig.imageLight}
    >
      <header className={getClassName(options, 'headerClassName', 'mb-4')}>
        <h1 className={getClassName(options, 'titleClassName', 'mb-4')}>
          {i18next.t('auth:activateResendHeader')}
        </h1>
        <p className={getClassName(options, 'introClassName', 'lead')}>
          {altHeader
            ? altHeader
            : i18next.t('auth:activateResendFromLogin')}
          <b>{email}</b>.
        </p>
      </header>

      <div className={getClassName(options, 'formActionsClassName', '')}>
        <div className={getClassName(options, 'clickableWrapperClassName', '')}>
          <AuthButtonPrimary
            kind="button"
            type="submit"
            disabled={readonly}
            label={
              readonly ? (
                <FormControls.SubmittingSpinner />
              ) : (
                i18next.t('auth:activateResendSubmit')
              )
            }
            onClick={() => null}
          />
        </div>
      </div>
    </FormSkeletonLayout>
  ))
}

export function resend_activation_success(
  options: options,
  email: string
): Widget<Updater<AuthState>> {
  return fromJSX((setState: (_: Updater<AuthState>) => void) => (
    <FormSkeletonLayout
      type="resend-activation-success"
      kind="text-image"
      onSubmit={() =>
        setState((s) => ({
          ...s,
          resendActivationState: 'resend activation - resending',
        }))
      }
      options={options}
      image={formSkeletonConfig.imageLight}
    >
      <header className={getClassName(options, 'headerClassName', 'mb-4')}>
        <h1 className={getClassName(options, 'titleClassName', 'mb-4')}>
          {i18next.t('auth:resetSuccessHeader')}
        </h1>
        <p className={getClassName(options, 'introClassName', 'lead')}>
          {i18next.t('auth:activateResendSuccessPre')} <b>{email}</b>
          {i18next.t('auth:activateResendSuccessPost')}
        </p>
      </header>
    </FormSkeletonLayout>
  ))
}

// This screen is not used
export function resend_activation_failure(
  options: options,
  email: string
): Widget<Updater<AuthState>> {
  return fromJSX(() => {
    return (
      <section className={getClassName(options, 'blockClassName', 'container')}>
        <div className={getClassName(options, 'innerClassName', 'py-5')}>
          <header className={getClassName(options, 'headerClassName', 'mb-4')}>
            <h1 className={getClassName(options, 'titleClassName', 'mb-4')}>
              Lost activation e-mail
            </h1>
            <p className={getClassName(options, 'introClassName', 'lead')}>
              {i18next.t('auth:newPassword')}
              {email}
            </p>
          </header>
        </div>
      </section>
    )
  })
}
